import { ITextVariables } from '@GFTypes/GameStoreTypes';

export const TEXT_VARIABLES_DEFAULTS: ITextVariables = {
    freeGamesTotalWin: '',
    respinsTotalWin: '',
    wildWallTotalWin: '',
    lockAndRollTotalWin: '',
    bonusPickTotalWin: '',

    freeGamesSpinsTotal: '',
    respinsSpinsTotal: '',
    wildWallSpinsTotal: '',
    lockAndRollSpinsTotal: '',
    bonusPickSpinsTotal: '',

    freeGamesSpinsPlayed: '',
    respinsSpinsPlayed: '',
    wildWallSpinsPlayed: '',
    lockAndRollSpinsPlayed: '',
    bonusPickSpinsPlayed: '',

    freeGamesSpinsWon: '',
    respinsSpinsWon: '',
    wildWallSpinsWon: '',
    lockAndRollSpinsWon: '',
    bonusPickSpinsWon: ''
};
